__turbopack_context__.v({
  "description": "InsuranceImageColTextForm-module-scss-module__1eCO3G__description",
  "formHeading": "InsuranceImageColTextForm-module-scss-module__1eCO3G__formHeading",
  "formTagline": "InsuranceImageColTextForm-module-scss-module__1eCO3G__formTagline",
  "imageSection": "InsuranceImageColTextForm-module-scss-module__1eCO3G__imageSection",
  "insuranceImageColTextForm": "InsuranceImageColTextForm-module-scss-module__1eCO3G__insuranceImageColTextForm",
  "insuranceImageColTextForm--imageSmallDesign": "InsuranceImageColTextForm-module-scss-module__1eCO3G__insuranceImageColTextForm--imageSmallDesign",
  "textSection": "InsuranceImageColTextForm-module-scss-module__1eCO3G__textSection",
});
